"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const gotoChat_1 = require("../../actions/chats/gotoChat");
const date_1 = require("../../formatters/date");
const ParticipantsTyping_1 = __importDefault(require("../shared/ParticipantsTyping"));
const TextContent_1 = __importDefault(require("../shared/TextContent"));
const ThemTyping_1 = __importDefault(require("../shared/ThemTyping"));
const DefaultGroupChatIcon_1 = __importDefault(require("../shared/DefaultGroupChatIcon"));
const UserAvatar_1 = __importDefault(require("../shared/UserAvatar"));
const useStyles = makeStyles_1.default((theme) => ({
    listItem: {
        backgroundColor: theme.colors.sidePanel.backgroundColor,
        "&:hover": {
            backgroundColor: theme.colors.sidePanel.listItemHoverBackgroundColor,
            cursor: "pointer"
        },
        "&.Mui-selected": {
            backgroundColor: theme.colors.sidePanel.listItemSelectedBackgroundColor
        }
    },
    chatSummary: {
        paddingLeft: 10,
        width: "100%",
        minWidth: 0
    },
    chatName: {
        visibility: props => props.name.length ? "visible" : "hidden"
    },
    latestMessage: {
        color: colorManipulator_1.alpha(theme.colors.textColor, 0.6),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    date: {
        color: colorManipulator_1.alpha(theme.colors.textColor, 0.6),
        float: "right"
    },
    unreadCount: {
        fontSize: "0.75rem",
        float: "right",
        backgroundColor: theme.colors.green.main,
        color: theme.colors.green.contrastText,
        lineHeight: "20px",
        borderRadius: 10,
        textAlign: "center",
        verticalAlign: "middle",
        minWidth: 20,
        padding: "0 4px"
    }
}));
exports.default = react_1.default.memo(ChatListItem);
function ChatListItem(props) {
    const dispatch = react_redux_1.useDispatch();
    const classes = useStyles(props);
    const icon = props.isGroup
        ? react_1.default.createElement(DefaultGroupChatIcon_1.default, { size: "md" })
        : react_1.default.createElement(UserAvatar_1.default, { isUserOnline: props.userOnline, userId: props.userId, imageId: props.userImageId, size: "md" });
    let snippet;
    if (props.themTyping) {
        snippet = react_1.default.createElement(ThemTyping_1.default, { variant: "body2" });
    }
    else if (props.participantsTyping.length) {
        snippet = react_1.default.createElement(ParticipantsTyping_1.default, { usernames: props.participantsTyping });
    }
    else {
        snippet = react_1.default.createElement(TextContent_1.default, { text: props.latestMessage, plainText: true, variant: "body2" });
    }
    return (react_1.default.createElement(ListItem_1.default, { selected: props.selected, onClick: () => dispatch(gotoChat_1.gotoChatByIndex(props.index)), className: classes.listItem, divider: true },
        react_1.default.createElement(ListItemIcon_1.default, null, icon),
        react_1.default.createElement("div", { className: classes.chatSummary },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Typography_1.default, { variant: "caption", className: classes.date }, props.date ? date_1.formatMessageDate(props.date) : null),
                react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.chatName }, props.name.length ? props.name : "Loading")),
            react_1.default.createElement("div", null,
                props.unreadCount > 0 ? react_1.default.createElement("div", { className: classes.unreadCount }, props.unreadCount) : null,
                react_1.default.createElement("div", { className: classes.latestMessage }, snippet)))));
}
